import { createContext } from "react";

export const SelectedCompaniesContext = createContext({
  selectedCompanyIds: "",
  changeCompanies: () => {}
});
